/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ConferenceBackend) {
      root.ConferenceBackend = {};
    }
    root.ConferenceBackend.Params2 = factory(root.ConferenceBackend.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Params2 model module.
   * @module model/Params2
   * @version 0.0.1
   */

  /**
   * Constructs a new <code>Params2</code>.
   * @alias module:model/Params2
   * @class
   */
  var exports = function() {
    var _this = this;


  };

  /**
   * Constructs a <code>Params2</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Params2} obj Optional instance to populate.
   * @return {module:model/Params2} The populated <code>Params2</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('_id')) {
        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} _id
   */
  exports.prototype['_id'] = undefined;



  return exports;
}));






// WEBPACK FOOTER //
// ./generated/src/model/Params2.js